// Single address only: commas/semicolons would let one field target several inboxes
const EMAIL_PATTERN = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/;

/**
 * @param {string} email
 * @returns {boolean} True when the value is exactly one plausible email address
 */
export const isValidEmail = (email) => typeof email === 'string' && EMAIL_PATTERN.test(email.trim());
